module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAYCAMAAACFivCBAAAAS1BMVEUAAABQbIVSbIZRbYdQbYc+ov4/pP9RbIdSbYdTbYg/of9RbYZRbIY9of49ov5VaopSbYdSbYdNeaFTbIZAov4/n/8zzP9SbYc/ov9bR5ThAAAAF3RSTlMAJOOAT24U+bM6gHDFTzoYrZGAWTcoBdw0u4gAAAB9SURBVDjL7dTJCoAgFIVhy+Z5rvd/0u6BEicIjVb5LyJFPzci04t3qYImdrmEiRmzYDla6jAiC1+p+8RSsZjS3yxOFa7WVqFFtzCuXa3sQGmwvrVQw1CwLPd+5FfztQ7/U0Wtz5Yosr9fWN9hZ/vO4pSX1ZsW8rVyqcHJOgG6DViRrEeSOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_ocrm.png
// module id = cxDD
// module chunks = 9